import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { Plan } from "@/redux/api/plans.rtkq";
import PlanNativeSelect from "./PlanNativeSelect";

interface PlanAssignmentProps {
  planId?: string;
  planName?: string;
  planActive?: boolean;
  plans: Plan[];
  onChange: (planId: string) => void;
  onRestore: (planId: string) => void;
  restoring?: boolean;
  className?: string;
}

/** Current plan stays visible when archived. Restore does not change the office plan. */
const PlanAssignment = ({
  planId,
  planName,
  planActive,
  plans,
  onChange,
  onRestore,
  restoring,
  className,
}: PlanAssignmentProps) => {
  const inactive = planActive === false;

  return (
    <div className={cn("flex flex-col items-end gap-1", className)}>
      {planId ? (
        <div className="flex items-center gap-1">
          {inactive && planName ? <span className="text-sm">{planName}</span> : null}
          <Badge variant={inactive ? "secondary" : "outline"}>{inactive ? "לא פעיל" : "פעיל"}</Badge>
        </div>
      ) : null}
      {inactive && planId ? (
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-7 text-xs"
          disabled={restoring}
          onClick={() => onRestore(planId)}
        >
          הפעל
        </Button>
      ) : null}
      <PlanNativeSelect value={planId} plans={plans} onChange={onChange} />
    </div>
  );
};

export default PlanAssignment;
